
export enum EmailStatusesEnum {
    PendingApproval = 1,
    SucceededApproved = 2,
    Rejected = 3,
    Failed = 4,
    SucceededAuto = 5,
    Blocked = 6
}